module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/audioPlay.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/audioplayselect/asset/audioPlay.png
// module id = 1269
// module chunks = 367